/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_NInputs */

const en_tut_akses_n = /** @type {(inputs: Tut_Akses_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A knock expires by itself after five minutes or when you leave the office. Changing an access policy ends conversations running in the office and cuts nearby audio — microphones do not come back on by themselves.`)
};

const id_tut_akses_n = /** @type {(inputs: Tut_Akses_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan masuk berakhir sendiri setelah lima menit atau saat Anda keluar kantor. Mengubah kebijakan akses mengakhiri percakapan yang sedang berjalan di kantor dan memutus audio sekitar — mikrofon tidak menyala kembali dengan sendirinya.`)
};

/**
* | output |
* | --- |
* | "A knock expires by itself after five minutes or when you leave the office. Changing an access policy ends conversations running in the office and cuts nearby..." |
*
* @param {Tut_Akses_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_n = /** @type {((inputs?: Tut_Akses_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_n(inputs)
	return en_tut_akses_n(inputs)
});